import React from 'react';
import { useOfferTimer } from '../../contexts/OfferTimerContext';

/**
 * Barra superior con el contador de la oferta individual de 2 horas.
 * El vencimiento se maneja en contexts/OfferTimerContext.tsx.
 */
export function CountdownBar() {
  const {
    remaining,
    expired,
    ready
  } = useOfferTimer();
  if (expired) {
    return <BarShell data-id="element-80" data-mp="3jeeste9fh789">
        <p className="text-[14px] font-bold text-[#4B3935] sm:text-[15px]" data-id="element-81" data-mp="3jdwtg8rgycw4">Esta oferta finalizó</p>
      </BarShell>;
  }
  const {
    h,
    m,
    s
  } = split(remaining);
  return <BarShell data-id="element-82" data-mp="fvlm9lf2hinl">
      <div className="flex flex-row items-center gap-2 sm:gap-3" role="timer" aria-live="off" data-id="element-83" data-mp="fw54724pw71m">
        <p className="whitespace-nowrap text-[12px] font-bold text-[#4B3935] min-[380px]:text-[13px] sm:text-[15px]" data-id="element-84" data-mp="1wlui4w9cnn7">
          <span aria-hidden="true" data-id="element-85" data-mp="60tmqc1xclq6">⏰ </span>Tu oferta especial termina en:
        </p>
        <p className={`flex shrink-0 items-center gap-0.5 font-display sm:gap-1 tabular-nums transition-opacity duration-150 ease-out ${ready ? 'opacity-100' : 'opacity-0'}`} aria-label={`${h} horas, ${m} minutos y ${s} segundos`} data-id="element-86" data-mp="2mm2vamp3qy34">
          <TimeBox value={h} data-id="element-87" data-mp="3o20qyzhpdbf1" />
          <Colon data-id="element-88" data-mp="3o2sc1gdobqr2" />
          <TimeBox value={m} data-id="element-89" data-mp="3o3bowiogvoy8" />
          <Colon data-id="element-90" data-mp="5w44zkz2ctir" />
          <TimeBox value={s} data-id="element-91" data-mp="5wno350g9nyd" />
        </p>
      </div>
    </BarShell>;
}
function BarShell({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="sticky top-0 z-50 border-b border-[#EADFCF] bg-[#FBD3E0] shadow-[0_2px_10px_rgba(139,107,85,0.10)]" data-id="element-92" data-mp="1wdivukhf1kk">
      <div className="mx-auto flex min-h-[2.75rem] max-w-6xl items-center justify-center px-3 py-2 sm:px-4 text-center text-[12.5px] font-semibold text-ink sm:text-sm" data-id="element-93" data-mp="auywdbb3jqeh">
        {children}
      </div>
    </div>;
}
function TimeBox({
  value
}: {
  value: string;
}) {
  return <span className="inline-flex min-w-[1.65rem] justify-center rounded-md bg-[#C2335F] px-1 py-0.5 text-[14px] font-extrabold leading-tight text-white sm:min-w-[2.1rem] sm:px-1.5 sm:text-[17px]" data-id="element-94" data-mp="kmuwerwqtqlc">
      {value}
    </span>;
}
function Colon() {
  return <span className="text-[14px] font-extrabold text-[#C2335F] sm:text-[16px]" aria-hidden="true" data-id="element-95" data-mp="3neg9vz6k490y">
      :
    </span>;
}
function split(ms: number) {
  const total = Math.floor(ms / 1000);
  const pad = (n: number) => String(n).padStart(2, '0');
  return {
    h: pad(Math.floor(total / 3600)),
    m: pad(Math.floor(total % 3600 / 60)),
    s: pad(total % 60)
  };
}